// Errores de la capa de datos: distingue fallas de red (se reintentan desde la cola offline)
// de rechazos del servidor (se revierte el cambio optimista y se avisa).

export class ApiError extends Error {
  constructor(
    message: string,
    readonly network: boolean,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

const NETWORK_PATTERNS = [
  /failed to fetch/i,
  /networkerror/i,
  /load failed/i,
  /network request failed/i,
  /fetch failed/i,
  /err_internet_disconnected/i,
  /err_network/i,
];

export function looksLikeNetworkMessage(message: string): boolean {
  return NETWORK_PATTERNS.some((p) => p.test(message));
}

export function isNetworkError(error: unknown): boolean {
  if (error instanceof ApiError) return error.network;
  if (error instanceof TypeError) return true;
  if (error && typeof error === 'object') {
    const e = error as { name?: string; message?: string };
    if (e.name === 'FunctionsFetchError' || e.name === 'AuthRetryableFetchError') return true;
    if (e.message && looksLikeNetworkMessage(e.message)) return true;
  }
  return false;
}

/** Traduce mensajes conocidos del servidor a textos para la interfaz. */
export function friendlyMessage(error: unknown): string {
  const raw = error instanceof Error ? error.message : String(error);
  if (/Database error saving new user|no está autorizado/i.test(raw)) {
    return 'Este correo no está autorizado para usar Tablero.';
  }
  if (/Invalid login credentials/i.test(raw)) return 'Correo o contraseña incorrectos.';
  if (/Email not confirmed/i.test(raw)) return 'Debes confirmar tu correo antes de ingresar.';
  if (isNetworkError(error)) return 'Sin conexión. Se aplicará al reconectar.';
  return raw;
}
